import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Title from "./Title";
import { useSelector } from "react-redux";
import {
  clearParameters,
  removeParameter,
  setDateParameters,
  setParameters,
} from "../redux/global/actions";
import {
  filterLicenses,
  getLicenseDetails,
  getLicenses,
  getLicensesBulk,
  sortLicenses,
} from "../redux/license/actions";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import MultiValueInput from "../inputs/multiValueInput";
import DateInput from "../inputs/dateInput";
import {
  Fab,
  Grid,
  Menu,
  MenuItem,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useEffect } from "react";
import "./Licenses.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchDateInput from "../inputs/searchDateInput";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { extractUserInfoFromToken, getLocalStorageSAMLToken } from "../utils";

export default function Licenses() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const queryParameters = useSelector((state) => state?.parameters?.licenses);

  const [currentLicenseId, setCurrentLicenseId] = React.useState();
  const [currentLicenseBusinessPartner, setCurrentLicenseBusinessPartner] =
    React.useState();
  const [currentLicenseOrderId, setCurrentLicenseOrderId] = React.useState();
  const [currentLicenseEndUser, setCurrentLicenseEndUser] = React.useState();

  const [filterLicenseId, setFilterLicenseId] = React.useState([]);
  const [filterBusinessPartner, setFilterBusinessPartner] = React.useState([]);
  const [filterEndUsers, setFilterEndUsers] = React.useState([]);
  const [filterSupportPartner, setFilterSupportPartner] = React.useState([]);
  const [filterOrderIds, setFilterOrderIds] = React.useState([]);

  const [filterCreationDateStart, setFilterCreationDateStart] =
    React.useState();
  const [filterCreationDateEnd, setFilterCreationDateEnd] = React.useState();
  const [filterModificationDateStart, setFilterModificationDateStart] =
    React.useState();
  const [filterModificationDateEnd, setFilterModificationDateEnd] =
    React.useState();

  const handleExecuteSearch = () => {
    let queryObject = {
      limit: 100,
    };
    if (queryParameters.licenseIds) {
      queryObject.license_id = queryParameters.licenseIds;
    }
    if (queryParameters.businessPartners) {
      queryObject.business_partner = queryParameters.businessPartners;
    }
    if (queryParameters.orderIds) {
      queryObject.order = queryParameters.orderIds;
    }
    if (queryParameters.endUsers) {
      queryObject.end_user = queryParameters.endUsers;
    }
    if (queryParameters.supportPartners) {
      queryObject.support_partner = queryParameters.supportPartners;
    }
    if (queryParameters.soldTos) {
      queryObject.sold_to = queryParameters.soldTos;
    }
    if (queryParameters.creationDateStart && queryParameters.creationDateEnd) {
      queryObject.creation_date_from = queryParameters.creationDateStart;
      queryObject.creation_date_to = queryParameters.creationDateEnd;
    }
    dispatch(getLicenses(queryObject));
  };

  const handleExecuteBulkSearch = () => {
    let queryObject = {};
    if (queryParameters.licenseIds) {
      queryObject.license_id = queryParameters.licenseIds;
    }
    if (queryParameters.businessPartners) {
      queryObject.business_partner = queryParameters.businessPartners;
    }
    if (queryParameters.orderIds) {
      queryObject.order = queryParameters.orderIds;
    }
    if (queryParameters.endUsers) {
      queryObject.end_user = queryParameters.endUsers;
    }
    if (queryParameters.supportPartners) {
      queryObject.support_partner = queryParameters.supportPartners;
    }
    if (queryParameters.soldTos) {
      queryObject.sold_to = queryParameters.soldTos;
    }
    if (queryParameters.creationDateStart && queryParameters.creationDateEnd) {
      queryObject.creation_date_from = queryParameters.creationDateStart;
      queryObject.creation_date_to = queryParameters.creationDateEnd;
    }
    const saml_token = getLocalStorageSAMLToken();
    const infoToken = extractUserInfoFromToken(saml_token);
    queryObject.email = infoToken.email;
    queryObject.request_user = infoToken.username;
    dispatch(getLicensesBulk(queryObject));
  };

  const handleExecuteFilter = () => {
    let filterObject = {};
    if (filterLicenseId?.length > 0) {
      filterObject.licenseId = [filterLicenseId];
    }
    if (filterBusinessPartner?.length > 0) {
      filterObject.businessPartner = [filterBusinessPartner];
    }
    if (filterEndUsers?.endUser > 0) {
      filterObject.endUser = [filterEndUsers];
    }
    if (filterSupportPartner?.orderIds > 0) {
      filterObject.orderIds = [filterOrderIds];
    }
    if (filterCreationDateStart) {
      filterObject.filterCreationDateStart = filterCreationDateStart;
    }
    if (filterCreationDateEnd) {
      filterObject.filterCreationDateEnd = filterCreationDateEnd;
    }
    if (filterModificationDateStart) {
      filterObject.filterModificationDateStart = filterModificationDateStart;
    }
    if (filterModificationDateEnd) {
      filterObject.filterModificationDateEnd = filterModificationDateEnd;
    }
    dispatch(filterLicenses(filterObject));
  };

  useEffect(() => {
    handleExecuteFilter();
  }, [
    filterLicenseId,
    filterBusinessPartner,
    filterEndUsers,
    filterSupportPartner,
    filterOrderIds,
    filterCreationDateStart,
    filterCreationDateEnd,
    filterModificationDateStart,
    filterModificationDateEnd,
  ]);

  function handleSelectLicense(licenseId) {
    dispatch(getLicenseDetails(licenseId));
    navigate("/licenses/details/" + licenseId);
  }

  const handleDeleteLicenseId = (chipToDelete) => () => {
    dispatch(removeParameter({ licenses: { licenseIds: [chipToDelete] } }));
  };
  const handleClearLicenseIds = () => {
    dispatch(clearParameters({ licenses: "licenseIds" }));
  };
  const handleDeleteLicenseOrderId = (chipToDelete) => () => {
    dispatch(removeParameter({ licenses: { orderIds: [chipToDelete] } }));
  };
  const handleClearLicenseOrderIds = () => {
    dispatch(clearParameters({ licenses: "orderIds" }));
  };
  const handleDeleteLicenseEndUser = (chipToDelete) => () => {
    dispatch(removeParameter({ licenses: { endUsers: [chipToDelete] } }));
  };
  const handleClearLicenseEndUsers = () => {
    dispatch(clearParameters({ licenses: "endUsers" }));
  };
  const handleDeleteLicenseBusinessPartner = (chipToDelete) => () => {
    dispatch(
      removeParameter({ licenses: { businessPartners: [chipToDelete] } }),
    );
  };
  const handleClearLicenseBusinessPartners = () => {
    dispatch(clearParameters({ licenses: "businessPartners" }));
  };

  const licenses = useSelector((state) => {
    if (state.filteredLicenses) {
      return state.filteredLicenses.map((license) => {
        return {
          license_id: license?.license_id,
          modification_date: license?.modification_date,
          creation_date: license?.creation_date,
          description: license?.description,
          start_date: license?.start_date,
          end_date: license?.end_date,
          part_number: license?.part_number,
          quantity: license?.quantity,
          sold_to: license?.sold_to?.applicant_id,
          status: license?.status,
          type: license?.type,
          orderId: license?.orderId,
        };
      });
    } else return [];
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(document.getElementById("menuAnchor"));
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterDescription =
    "Add filters to the list of results, and export the filtered list to CSV (currently not implemented for contracts)";

  const [sortDirection, setSortDirection] = React.useState("");
  const [sortParameter, setSortParameter] = React.useState("");

  const handleSortLicenses = (sortParameter) => {
    setSortParameter(sortParameter);
    if (sortDirection === "") {
      setSortDirection("ascending");
      dispatch(sortLicenses(sortParameter, "ascending"));
    } else if (sortDirection === "ascending") {
      setSortDirection("descending");
      dispatch(sortLicenses(sortParameter, "descending"));
    } else {
      setSortDirection("ascending");
      dispatch(sortLicenses(sortParameter, "ascending"));
    }
  };

  const [openBulkConfirmation, setOpenBulkConfirmation] = React.useState(false);
  const [openBulkMessage, setOpenBulkMessage] = React.useState(false);

  const handleKeydown = (event) => {
    if (event.key == "Enter") {
      event.stopPropagation();
      event.preventDefault();
      setTimeout(() => {
        handleExecuteSearch();
      }, 0);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeydown);
    return () => {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  return (
    <React.Fragment>
      <Modal
        open={openBulkMessage}
        style={{
          textAlign: "center",
          paddingTop: "45vh",
        }}
      >
        <>
          <Typography style={{ color: "white" }}>
            Your query has been sent. You can follow the status in the Bulk
            Report page or wait for the Rainbow message that will announce the
            end of the export.
          </Typography>
          <div style={{ paddingBottom: "1%" }} />
          <Grid container className="headercontainer">
            <Grid item>
              <Button
                style={{
                  color: "white",
                  background: "#6b469e",
                }}
                onClick={() => {
                  setOpenBulkMessage(false);
                }}
              >
                Ok
              </Button>
            </Grid>
          </Grid>
        </>
      </Modal>
      <Modal
        open={openBulkConfirmation}
        style={{
          textAlign: "center",
          paddingTop: "45vh",
        }}
      >
        <>
          <Typography style={{ color: "white" }}>
            This query could take a few minutes, are you sure you want to
            continue?
          </Typography>
          <div style={{ paddingBottom: "1%" }} />
          <Grid container className="headercontainer">
            <Grid item>
              <Button
                style={{
                  color: "white",
                  background: "#6b469e",
                }}
                onClick={() => {
                  handleExecuteBulkSearch();
                  setOpenBulkConfirmation(false);
                  setOpenBulkMessage(true);
                }}
              >
                Yes
              </Button>
            </Grid>
            <Grid item style={{ width: "7%" }} />
            <Grid item>
              <Button
                style={{
                  color: "white",
                  background: "#6b469e",
                }}
                onClick={() => setOpenBulkConfirmation(false)}
              >
                No
              </Button>
            </Grid>
          </Grid>
        </>
      </Modal>
      <MultiValueInput
        setCurrentParam={setCurrentLicenseId}
        setQueryParams={setParameters}
        currentParam={currentLicenseId}
        queryParams={queryParameters?.licenseIds}
        handleDelete={handleDeleteLicenseId}
        handleClear={handleClearLicenseIds}
        label="License ID"
        family="licenses"
        type="licenseIds"
      />
      <MultiValueInput
        setCurrentParam={setCurrentLicenseBusinessPartner}
        setQueryParams={setParameters}
        currentParam={currentLicenseBusinessPartner}
        queryParams={queryParameters?.businessPartners}
        handleDelete={handleDeleteLicenseBusinessPartner}
        handleClear={handleClearLicenseBusinessPartners}
        label="Business Partner"
        family="licenses"
        type="businessPartners"
      />
      <MultiValueInput
        setCurrentParam={setCurrentLicenseOrderId}
        setQueryParams={setParameters}
        currentParam={currentLicenseOrderId}
        queryParams={queryParameters?.orderIds}
        handleDelete={handleDeleteLicenseOrderId}
        handleClear={handleClearLicenseOrderIds}
        label="Order ID"
        family="licenses"
        type="orderIds"
      />
      <MultiValueInput
        setCurrentParam={setCurrentLicenseEndUser}
        setQueryParams={setParameters}
        currentParam={currentLicenseEndUser}
        queryParams={queryParameters?.endUsers}
        handleDelete={handleDeleteLicenseEndUser}
        handleClear={handleClearLicenseEndUsers}
        label="End User"
        family="licenses"
        type="endUsers"
      />
      <Grid>
        <SearchDateInput
          title={"Creation Date"}
          setFilterDate={setDateParameters}
          family="licenses"
          type="creationDateStart"
          type2="creationDateEnd"
        />
      </Grid>
      <Grid
        container
        style={{
          justifyContent: "center",
        }}
      >
        <Grid item>
          <Button
            variant="contained"
            onClick={handleExecuteSearch}
            style={{ width: "15vw" }}
          >
            Search
          </Button>
        </Grid>
        <div style={{ paddingLeft: "0.2%" }} />
        <Grid item>
          <Button
            variant="contained"
            onClick={() => setOpenBulkConfirmation(true)}
            style={{ width: "15vw" }}
          >
            Bulk Export
          </Button>
        </Grid>
      </Grid>
      <Title>Licenses</Title>
      <Typography>
        {licenses?.length
          ? licenses?.length === 100
            ? licenses?.length + " results, use bulk export for more"
            : licenses?.length + " results"
          : null}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="License ID"
                    variant="standard"
                    onChange={(e) => {
                      setFilterLicenseId(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortLicenses("license_id")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "license_id" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "license_id" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>Creation Date</Grid>
                <Grid item onClick={() => handleSortLicenses("creation_date")}>
                  {sortDirection === "ascending" &&
                  sortParameter === "creation_date" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "creation_date" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>Modification Date</Grid>
                <Grid
                  item
                  onClick={() => handleSortLicenses("modification_date")}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "modification_date" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "modification_date" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Type"
                    variant="standard"
                    onChange={(e) => {
                      setFilterBusinessPartner(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortLicenses("type")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" && sortParameter === "type" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "type" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Sold To"
                    variant="standard"
                    onChange={(e) => {
                      setFilterBusinessPartner(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortLicenses("sold_to.applicant_id")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "sold_to.applicant_id" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "sold_to.applicant_id" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Status"
                    variant="standard"
                    onChange={(e) => {
                      setFilterSupportPartner(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortLicenses("status")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "status" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "status" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className="headercontainer">
                <Grid item>
                  <TextField
                    label="Order ID"
                    variant="standard"
                    onChange={(e) => {
                      setFilterOrderIds(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortLicenses("orderId")}
                  style={{ alignSelf: "center" }}
                >
                  {sortDirection === "ascending" &&
                  sortParameter === "orderId" ? (
                    <KeyboardArrowDownIcon className="sortbutton" />
                  ) : sortDirection === "descending" &&
                    sortParameter === "orderId" ? (
                    <KeyboardArrowUpIcon className="sortbutton" />
                  ) : (
                    <UnfoldMoreIcon className="sortbutton" />
                  )}
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {licenses.map((row) => (
            <TableRow
              hover
              key={row?.license_id}
              onClick={() => handleSelectLicense(row?.license_id)}
              style={{
                cursor: "pointer",
              }}
            >
              <TableCell>{row?.license_id}</TableCell>
              <TableCell>{row?.creation_date}</TableCell>
              <TableCell>{row?.modification_date}</TableCell>
              <TableCell>{row?.type}</TableCell>
              <TableCell>{row?.sold_to}</TableCell>
              <TableCell>{row?.status}</TableCell>
              <TableCell>{row?.orderId}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Tooltip
        title={<Typography fontSize={17}>{filterDescription}</Typography>}
      >
        <Fab
          style={{
            position: "absolute",
            right: 10,
            bottom: 10,
            backgroundColor: "#6b469e",
            color: "white",
            height: "5em",
            width: "5em",
          }}
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <div
            id="menuAnchor"
            style={{
              position: "relative",
              bottom: 500,
              right: 250,
            }}
          ></div>
          <FileDownloadIcon
            fontSize="large"
            style={{ height: "70%", width: "70%" }}
          />
        </Fab>
      </Tooltip>
      <div>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem>
            <TextField
              label="License ID"
              onChange={(e) => {
                setFilterLicenseId(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <Grid>
              <div>Creation Date</div>
              <DateInput
                setFilterDateStart={setFilterCreationDateStart}
                setFilterDateEnd={setFilterCreationDateEnd}
              />
            </Grid>
          </MenuItem>
          <MenuItem>
            <Grid>
              <div>Modification Date</div>
              <DateInput
                setFilterDateStart={setFilterModificationDateStart}
                setFilterDateEnd={setFilterModificationDateEnd}
              />
            </Grid>
          </MenuItem>
          <MenuItem>
            <TextField
              label="Type"
              onChange={(e) => {
                setFilterBusinessPartner(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <TextField
              label="Sold To"
              onChange={(e) => {
                setFilterEndUsers(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <TextField
              label="Status"
              onChange={(e) => {
                setFilterSupportPartner(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
            />
          </MenuItem>
          <MenuItem>
            <Button
              variant="contained"
              disabled
              onClick={() => {
                //handleExportToCSV(materials)
              }}
            >
              Export licenses
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              variant="contained"
              disabled
              onClick={() => {
                //handleExportToCSV(materials)
              }}
            >
              Export materials
            </Button>
          </MenuItem>
        </Menu>
      </div>
    </React.Fragment>
  );
}
